import './floatingFeedback.scss';

import React, { useContext } from 'react';

import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { FeedbackContext } from '../../contexts/feedback/feedbackContext';
import SingleFeedback from './SingleFeedback';

export default function FloatingFeedback(props: { className?: string }) {
    const { className } = props;

    const { alerts } = useContext(FeedbackContext);

    return (
        <div className={`feedbackContainer ${className}`}>
            <div className='feedbackContent'>
                <TransitionGroup>
                    {alerts.length &&
                        alerts.map((alert, index) => (
                            <CSSTransition
                                key={index}
                                timeout={300}
                                classNames='item'
                            >
                                <SingleFeedback alert={alert} index={index} />
                            </CSSTransition>
                        ))}
                </TransitionGroup>
            </div>
        </div>
    );
}
